import React from "react";

function FaqItem({ q, children }) {
  return (
    <div style={{ marginTop: 16 }}>
      <div style={{ fontWeight: 700 }}>{q}</div>
      <div className="jh-note" style={{ marginTop: 6 }}>
        {children}
      </div>
    </div>
  );
}

function FaqPage() {
  return (
    <section className="jh-container jh-section">
      <h1 className="jh-title">FAQs</h1>
      <p className="jh-sub" style={{ maxWidth: 760, margin: "0 auto" }}>
        Answers to common questions about custom jewelry, production timelines,
        and shipping.
      </p>

      <div style={{ maxWidth: 760, margin: "12px auto 0 auto" }}>
        <FaqItem q="How long does it take to make my order?">
          Every piece is handmade to order. Please allow 2–3 weeks for
          production.
        </FaqItem>

        <FaqItem q="Do you offer returns or exchanges?">
          Because items are made to order, returns may be limited. If something
          arrives damaged or incorrect, contact us and we’ll make it right.
        </FaqItem>

        <FaqItem q="Can I change my order after placing it?">
          If production hasn’t started yet, we can usually help. Email us as
          soon as possible with your order details.
        </FaqItem>

        <FaqItem q="How do I choose my ring size?">
          If you’re unsure, we recommend visiting a local jeweler for sizing. If
          you have questions, send us a message and we’ll help.
        </FaqItem>

        <FaqItem q="Do you ship internationally?">
          We currently ship within the United States. If you’re located outside
          the U.S., contact us and we’ll be happy to review your request and
          provide an international shipping quote.
        </FaqItem>

        <FaqItem q="How can I contact support?">
          Email support@ridleyjewelry.com.
        </FaqItem>
      </div>
    </section>
  );
}

export default FaqPage;
